<template>
  <div :style="style" class="control-container" @click="demoOnly">
    <div class="control-row title">
        <CktextComponent :rawHtml="control.data.data.title">    
        </CktextComponent>
        <div v-if="control.data.data.misc.required" class="required">*</div>
    </div>
    <div class="control-row">
        <CktextComponent :rawHtml="control.data.data.subtitle">    
        </CktextComponent>
    </div>
    <div class="control-row input-container">
        <span class="iconfont icon-shoujihao" style="margin-right:0.2rem"></span>
        <input type="text" :placeholder="$t('message.enter_mobile')" class="input-outline-none"/>
    </div>   
  </div>
</template>

<script>
import CktextComponent from '../CkText.vue';

export default {
  name: 'MobileControl',
  components: {
    CktextComponent
  },
  data(){
    return {
      style:''
    }
  },
  props: {
    control: null
  },
  methods:{
    demoOnly(){

      const msg=this.$t('message.form_unavailable_h5');
        
      this.$toast.add({severity:'error', summary: this.$common.TITLE, detail:msg, life: 3000});
    
    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control-container:last-child{
      margin-bottom: 0px;
  }
  .control-row{
      margin-bottom: 10px;
      text-align:left;
  }

  .title{
      display: flex;
  }
  .required{
    color:#f7363f;
  }   
  .input-container{
      padding: 10px;
      border:1px solid #ced4da;
      border-radius:3px;
  }
  .input-outline-none{
      outline: none;
      border-width: 0px;
  }
</style>